import { UmbracoControls } from '@shared/types';

export const getUmbracoUrl = (data: UmbracoControls.MultiUrlPicker): string => data?.[0]?.url || '';
